import { whenDomReady } from "@allwyn/utils/document-ready";
import { mountConsentOverlay } from "@sazka/gdpr/consent-overlay/consent-overlay";
import { resolveViteImageAsset } from "@sazka/shared-components/vite-image/vite-image-resolver";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";

async function initConsentOverlay() {
    await showConsentOverlay();

    eventBus.on(GlobalEvents.ConsentsChanged, async () => {
        await showConsentOverlay();
    });
}

async function showConsentOverlay() {
    const videoElements = document.querySelectorAll<HTMLElement>(".ds-rich-text-video");

    if (!videoElements) return;

    videoElements.forEach(async (el) => {
        const element = el;
        const embedUrl = `//www.youtube-nocookie.com/embed/${element.dataset.videoCode}`;
        const externalUrl = `https://www.youtube.com/watch?v=${element.dataset.videoCode}`;

        const { avifSrc, fallbackType, src } = resolveViteImageAsset("shared/img/gdpr/visual-video.jpg");

        const overlayAdded = await mountConsentOverlay({
            target: element,
            externalContentUrl: externalUrl,
            backgroundImage: src,
            backgroundImageSet:
                avifSrc && fallbackType
                    ? `image-set(url("${avifSrc}") type("image/avif"), url("${src}") type("${fallbackType}"))`
                    : undefined,
        });
        const videoShown = element.querySelector("iframe");

        if (!overlayAdded && !videoShown) {
            element.insertAdjacentHTML("afterbegin", `<iframe src="${embedUrl}" allowfullscreen></iframe>`);
        }
    });
}

await whenDomReady();
initConsentOverlay();
